import { render, staticRenderFns } from "./DetalheFluxoDeCaixa.vue?vue&type=template&id=0d1841fa&scoped=true"
import script from "./DetalheFluxoDeCaixa.vue?vue&type=script&lang=js"
export * from "./DetalheFluxoDeCaixa.vue?vue&type=script&lang=js"
import style0 from "./DetalheFluxoDeCaixa.vue?vue&type=style&index=0&id=0d1841fa&prod&lang=scss&scoped=true"
import style1 from "./DetalheFluxoDeCaixa.vue?vue&type=style&index=1&id=0d1841fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1841fa",
  null
  
)

export default component.exports